import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, ChevronRight } from 'lucide-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { LegendCategory } from '../../models';
import { ImpactLegendItemComponent } from '../impact-legend-item/impact-legend-item.component';
import { FormatCo2eService } from 'src/app/shared/services/format-co2e.service';

@Component({
  selector: 'app-impact-legend-category',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    TranslocoModule,
    ImpactLegendItemComponent
  ],
  templateUrl: './impact-legend-category.component.html',
  styles: []
})
export class ImpactLegendCategoryComponent {
  @Input() category!: LegendCategory;
  @Input() categoryIndex!: number;
  @Input() perPerson: boolean = false;

  formatCo2e = inject(FormatCo2eService);

  @Output() categoryToggle = new EventEmitter<void>();
  @Output() categoryHeaderHover = new EventEmitter<void>();
  @Output() categoryHeaderLeave = new EventEmitter<void>();
  @Output() itemHover = new EventEmitter<number>();
  @Output() itemLeave = new EventEmitter<void>();

  readonly chevronRightIcon = ChevronRight;

  onToggleCategory(): void {
    this.categoryToggle.emit();
  }

  onCategoryHeaderEnter(): void {
    this.categoryHeaderHover.emit();
  }

  onCategoryHeaderLeave(): void {
    this.categoryHeaderLeave.emit();
  }

  onItemHover(itemIndex: number): void {
    this.itemHover.emit(itemIndex);
  }

  onItemLeave(): void {
    this.itemLeave.emit();
  }
}
